import 'css-chunksrc/client/scenes/strategicAxisCreation/form/tag/styles.scss';export default {
  "tag": "_tag_1haeu_1"
};